"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.outerDefaults = exports.innerDefaults = void 0;
exports.useCellSpacing = useCellSpacing;
var _react = require("react");
var _cdsUtils = require("@cbhq/cds-utils");
var _cell = require("../tokens/cell");
const innerDefaults = _cell.defaultSpacingConfig.innerSpacing;
exports.innerDefaults = innerDefaults;
const outerDefaults = _cell.defaultSpacingConfig.outerSpacing;
exports.outerDefaults = outerDefaults;
/**
 * Takes the inner and outerSpacing props from the Cell component and merges with their default values.
 */
function useCellSpacing({
  innerSpacing,
  outerSpacing
} = _cdsUtils.emptyObject) {
  return (0, _react.useMemo)(() => {
    var _innerSpacing$spacing, _innerSpacing$spacing2, _outerSpacing$spacing, _outerSpacing$spacing2;
    return {
      inner: Object.assign({}, innerDefaults, {
        spacingHorizontal: (_innerSpacing$spacing = innerSpacing === null || innerSpacing === void 0 ? void 0 : innerSpacing.spacing) !== null && _innerSpacing$spacing !== void 0 ? _innerSpacing$spacing : innerDefaults.spacingHorizontal,
        spacingVertical: (_innerSpacing$spacing2 = innerSpacing === null || innerSpacing === void 0 ? void 0 : innerSpacing.spacing) !== null && _innerSpacing$spacing2 !== void 0 ? _innerSpacing$spacing2 : innerDefaults.spacingVertical
      }, innerSpacing),
      outer: Object.assign({}, outerDefaults, {
        spacingHorizontal: (_outerSpacing$spacing = outerSpacing === null || outerSpacing === void 0 ? void 0 : outerSpacing.spacing) !== null && _outerSpacing$spacing !== void 0 ? _outerSpacing$spacing : outerDefaults.spacingHorizontal,
        spacingVertical: (_outerSpacing$spacing2 = outerSpacing === null || outerSpacing === void 0 ? void 0 : outerSpacing.spacing) !== null && _outerSpacing$spacing2 !== void 0 ? _outerSpacing$spacing2 : outerDefaults.spacingVertical
      }, outerSpacing)
    };
  }, [innerSpacing, outerSpacing]);
}